import React, {Component} from 'react';
import {Table} from 'react-data-components';
import EditChapterPart from "../EditChapterPart/EditChapterPart";
import moment from 'moment';
import api from '../../utils/api';

const questionTemplate = {
    question: '',
    optionA: '',
    optionB: '',
    optionC: '',
    optionD: '',
    correctOption: '',
    concept: ''
}

const courses = [
    {
        course: 'MCAT',
        subject: 'Maths',
        title: 'Angelfish piranha alas hey much b',
        options: 'options',
        id: '000010'
    },
    {
        course: 'LSAT',
        subject: 'Physics',
        title: 'Justly away shaky re-laid including therefore m',
        options: 'options',
        id: '000020'
    },
    {
        course: 'GMAT',
        subject: 'Maths',
        title: 'Shrank less unlocked messy without bird hellish',
        options: 'options',
        id: '000030'
    },
    {
        course: 'GMAT',
        subject: 'Physics',
        title: 'Debating me breeding be answered an',
        options: 'options',
        id: '000040'
    },
    {
        course: 'MCAT',
        subject: 'Chemistry',
        title: 'His followed carriage proposal entrance',
        options: 'options',
        id: '000050'
    },
    {
        course: 'MCAT',
        subject: 'Chemistry',
        title: 'Literature admiration frequently indulgence',
        options: 'options',
        id: '000060'
    },
    {
        course: 'MCAT',
        subject: 'Physics',
        title: 'Mandrill insufferable ouc',
        options: 'options',
        id: '000070'
    },
    {
        course: 'GMAT',
        subject: 'Chemistry',
        title: 'More preparatory much derisively far impul',
        options: 'options',
        id: '000080'
    },
    {
        course: 'LSAT',
        subject: 'Chemistry',
        title: 'More preparatory much derisively fa',
        options: 'options',
        id: '000090'
    }
];

const questions = [
    {
        id: '0020201',
        title: 'Question',
        number: 1,
        description: '',
        removeQuestion: false,
        checkedOption: 'C',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: '',
        finish: 0
    }
];

const testTemplate = {
    name: '',
    show_description: '',
    instructions: '',
    course: '',
    subject: '',
    type: 'test',
    sections: [
        {name: '', questions: [], subjectId: ''}
    ]
}

class EditChapterTest extends Component {
    state = {
        columns: [],
        activeCourse: {},
        activeSection: 0,
        test: {
            name: '',
            number: null,
            show_description: '',
            instructions: '',
            course: '',
            status: true,
            type: 'test',
            subject: '',
            sections: [
                {name: '', subjectId: '', questions: []}
            ]
        },
        currentTab: 0,
        view: 'add'
    };

    //Renders
    renderOptions = (val, row) => {
        return (
            <div className="dropdown">
                <a href="#"
                   data-toggle="dropdown"
                   className="btn btn-default"
                >
                    Options
                </a>
                <ul className="dropdown-menu pull-right">
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.props.setTest(row);
                        }}>
                            <i className="zmdi zmdi-plus-circle"/> Set as Courses Test
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            let test = JSON.parse(JSON.stringify(row));
                            delete test.id;
                            test.title = test.title + " (copy)";
                            this.props.saveTest(test, this.props.user.id);
                        }}>
                            <i className="zmdi zmdi-copy"

                            /> Copy Test
                        </a>
                    </li>
                    <li>
                        <a href="#"  onClick={(e) => {
                            e.preventDefault();
                            this.setState({test: JSON.parse(JSON.stringify(row)), activeCourse: this.props.courses.filter(c => c.id == JSON.parse(JSON.stringify(row)).courseId)[0], currentTab: 1});
                        }}>
                            <i className="zmdi zmdi-edit"
                            /> Edit Test
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.setState({test: testTemplate, currentTab: 1});
                        }}>
                            <i className="zmdi zmdi-plus-circle"/> Add Test
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.props.deleteTest(row.id, this.props.user.id);
                        }}>
                            <i className="zmdi zmdi-delete" /> Delete
                        </a>
                    </li>
                </ul>
            </div>
        )
    }


    

    saveTest = () => {

        let test = JSON.parse(JSON.stringify(this.state.test));


        let finish = test.finish;

        if(finish.split(":").length == 3) {
            finish = moment.duration(finish).asSeconds();
        }else if(finish.split(":").length == 2){
            finish = moment.duration("00:" + finish).asSeconds()
        }else{
            finish = moment.duration("00:00:" + finish).asSeconds()
        }

        test.finish = finish;

        this.props.saveTest(test, this.props.user.id);

    }

    //Renders
    renderContentHeader = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <div className="pull-right">

                        <button type="button" className="btn btn-primary" onClick={this.saveTest}>Save changes</button>
                    </div>
                    <h1 className="m-n font-thin h3 text-black">
                        <a className="back-button" onClick={(e) => {
                            e.preventDefault();
                            this.props.history.goBack();
                        }}>
                            <i className={"zmdi zmdi-arrow-left"}></i>
                        </a> {(this.props.test.id) ? 'Edit' : 'Add'} Chapter Test
                    </h1>
                    <small className="text-muted">

                    </small>
                </div>
            </div>
        </div>
    );

    componentWillMount(){
        if(this.props.match.params.number && !this.state.test.number){
            let {test} = this.state;
            test.number = this.props.match.params.number;
            test.courseSubjectId = this.props.match.params.subjectId;

            if(test.finish) {

                if (test.finish >= 3660) {
                    test.finish = moment.utc(test.finish * 1000).format('HH:mm:ss');
                } else if (test.finish >= 60) {
                    test.finish = moment.utc(test.finish * 1000).format('mm:ss');
                } else {
                    test.finish = moment.utc(test.finish * 1000).format('mm:ss');
                }
            }else{
                test.finish = "00:00:00";
            }


            this.setState({test});
        }else if(this.props.match.params.id){
            this.props.getTest(this.props.match.params.id, this.props.user.id);
        }
    }
    
    uploadFile = (e, sectionIndex, index) => {
        if(e.target.files.length > 0){
            const data = new FormData();
            data.append('file', e.target.files[0], this.props.profile.id + "-" + new Date().getTime().toString() + "-" + e.target.files[0].name);

            this.props.uploadFile(data, this.props.profile.id, {f: "question", index: index, sectionIndex: sectionIndex}, this.props.user.id);
         }

    }


    renderQuestions = (sections) => {
        if(this.state.test.type === 'answer'){
            return sections[this.state.activeSection].questions.map((item, index) => (
                <div className="table-question sm-bottom0" key={index}>
                    <div className="table-question-row">
                        <ul>
                            <li className="question-number"><input type="text" className="form-control AnswerSheetQuestionNumber" readOnly={true} value={index + 1} /> </li>
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1A`} name="Question1" value="A" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }} />
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1A`} className={item.correctOption === 'A' ? 'active' : ''}>A</label>
                                <div className="selected"></div>
                            </li>
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1B`} name="Question1" value="B" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }}/>
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1B`} className={item.correctOption === 'B' ? 'active' : ''}>B</label>
                                <div className="selected"></div>
                            </li>
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1C`} name="Question1" value="C" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }}/>
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1C`} className={item.correctOption === 'C' ? 'active' : ''}>C</label>
                                <div className="selected"></div>
                            </li>
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1D`} name="Question1" value="D" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }} />
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1D`} className={item.correctOption === 'D' ? 'active' : ''}>D</label>
                                <div className="selected"></div>
                            </li>
                            {this.props.test.answer_choices == 5 &&
                            <li className="QuestionAble">
                                <input type="radio" id={`${this.state.activeSection}-${index}-Option1E`} name="Question1" value="E" onClick={e => {
                                    e.preventDefault();
                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                }} />
                                <label htmlFor={`${this.state.activeSection}-${index}-Option1E`} className={item.correctOption === 'E' ? 'active' : ''}>E</label>
                                <div className="selected"></div>
                            </li>
                            }
                            <li className="question-number"><a href="#" className="" onClick={(e) => {
                                        e.preventDefault();
                                        this.props.deleteQuestion({sectionIndex: this.state.activeSection, index: index});
                                    }}><i className="zmdi zmdi-delete"></i> </a></li>

                        </ul>
                    </div>
                </div>
                ))
        }else{
            if(this.state.activeSection >= 0 && sections[this.state.activeSection]){
                return sections[this.state.activeSection].questions.map((item, index) => (
                    <div
                        key={index}
                        className="panel customPanel"
                    >
                        <div className="panel-heading border-bottom bg-light">
                            <div className="panel-control">
                                <a
                                    href="#"
                                    className="btn btn-danger"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.props.deleteQuestion({sectionIndex: this.state.activeSection, index: index});
                                    }}
                                >
                                    <i className="zmdi zmdi-delete"/>
                                </a>
                            </div>
                            <h3 className="panel-title">
                                {item.title}
                                <span className="new_test_question_number">
                                {item.number}
                            </span>
                            </h3>
                        </div>
                        <div className="panel-body bg-light-2">
                            <div className="row">
    
                                <div className="col-sm-7">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <label>Correct Option</label>
                                            <select
                                                className="form-control"
                                                value={this.props.test.sections[this.state.activeSection].questions[index].correctOption}
                                                onChange={(e) => {
                                                    this.props.updateQuestion(this.state.activeSection, index, 'correctOption', e.target.value);
                                                }}>
                                                <option value="">Select correct answer</option>
                                                <option value={"A"}>A</option>
                                                <option value={"B"}>B</option>
                                                <option value={"C"}>C</option>
                                                <option value={"D"}>D</option>
                                                {this.props.test.answer_choices == 5 &&
                                                <option value={"E"}>E</option>
                                                }
    
                                            </select>
    
                                        </div>
    
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="sm-top10">
                                        <br/>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Concept"
                                            value={item.concept}
                                            onChange={(e) => {
                                                this.props.updateQuestion(this.state.activeSection, index, 'concept', e.target.value);
                                            }}
                                        />
                                    </div>
                                    <br/>
                                    <div className="sm-top10">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Question"
                                            value={item.question}
                                            onChange={(e) => {
                                                this.props.updateQuestion(this.state.activeSection, index, 'question', e.target.value);
                                            }}
                                        />
                                    </div>
                                    <br/>
                                    <div className="sm-top10">
                                    <textarea
                                        className="form-control"
                                        placeholder="Option A"
                                        rows="2"
                                        value={item.optionA}
                                        onChange={(e) => {
                                            this.props.updateQuestion(this.state.activeSection, index, 'optionA', e.target.value);
                                        }}
                                    />
                                    </div>
                                    <br/>
                                    <div className="sm-top10">
                                    <textarea
                                        className="form-control"
                                        placeholder="Option B"
                                        rows="2"
                                        value={item.optionB}
                                        onChange={(e) => {
                                            this.props.updateQuestion(this.state.activeSection, index, 'optionB', e.target.value);
                                        }}
                                    />
                                    </div>
                                    <br/>
                                    <div className="sm-top10">
                                    <textarea
                                        className="form-control"
                                        placeholder="Option C"
                                        rows="2"
                                        value={item.optionC}
                                        onChange={(e) => {
                                            this.props.updateQuestion(this.state.activeSection, index, 'optionC', e.target.value);
                                        }}
                                    />
                                    </div>
                                    <br/>
                                    <div className="sm-top10">
                                    <textarea
                                        className="form-control"
                                        placeholder="Option D"
                                        rows="2"
                                        value={item.optionD}
                                        onChange={(e) => {
                                            this.props.updateQuestion(this.state.activeSection, index, 'optionD', e.target.value);
                                        }}
                                    />
                                    </div>
    
                                    {this.props.test.answer_choices == 5 &&
                                    <div className="sm-top10">
                                    <textarea
                                        className="form-control"
                                        placeholder="Option E"
                                        rows="2"
                                        value={item.optionE}
                                        onChange={(e) => {
                                            this.props.updateQuestion(this.state.activeSection, index, 'optionE', e.target.value);
                                        }}
                                    />
                                    </div>
                                    }
                                    
                                    
                                    {["quiz", "mcat"].indexOf(this.props.test.type) > -1 &&
                                        
                                               
                                                <div className="">
                                                {item.image &&
                                                    <img
                                                        className="test-question-image"
                                                        src={api.makeFileURL(item.image, this.props.user.id)}
                                                        alt="user"
                                                    />
                                                  
                                                }
                                                <br />
                                                    <span className="btn btn-default btn-file">
                                                        <span className="fileinput-new">
                                                            <i className="zmdi zmdi-upload"/>
                                                            {item.image ?
                                                                'Replace Image'
                                                                :
                                                                'Upload Image'
                                                            }
                                                        </span>
                                                        
                                                        <input
                                                            type="file"
                                                            onChange={e => this.uploadFile(e, this.state.activeSection, index)}
                                                            accept="image/*" 
                                                        />
                                                    </span>
                                                </div>
                                             
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
        }
    }

    componentWillUpdate(props){
        if(props.test.id && !this.props.test.id && this.props.match.params.number){
            // we've just saved and now can redirect;
            this.props.history.push(`/edit-chapter-test/${props.test.id}`);
        }else if(props.test.id && !this.state.test.id){

            let {test} = JSON.parse(JSON.stringify(props));

            if(test.finish) {

                if (test.finish >= 3660) {
                    test.finish = moment.utc(test.finish * 1000).format('HH:mm:ss');
                } else if (test.finish >= 60) {
                    test.finish = moment.utc(test.finish * 1000).format('mm:ss');
                } else {
                    test.finish = moment.utc(test.finish * 1000).format('mm:ss');
                }
            }else{
                test.finish = "00:00:00";
            }

            this.setState({test});
        }






    }

    //Lifecycle
    componentDidMount() {
        this.setState({
            columns: [
                {title: 'Course', prop: 'course'},
                {title: 'Subject', prop: 'subject'},
                {title: 'Title', prop: 'title'},
                {title: 'Options', prop: 'options', render: this.renderOptions}
            ]
        })
    }
    render() {
        return (
            <div
                className="content-wrapper"
                id="content-container"
            >
                {this.renderContentHeader()}
                <div className="content">
                    <div className="">
                        <div className="">
                            <div className="nav-tabs-custom ">

                                <div className="tab-content">

                                    <div className={"tab-pane active no-padding"}  id="tab_22">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Title</label>
                                                        <input type="text" className="form-control"
                                                               value={this.state.test.name || ''}
                                                               onChange={(e) => {
                                                                   let {test} = this.state;
                                                                   test.name = e.target.value;
                                                                   this.setState({test})
                                                               }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label>Show Description</label>
                                                        <select className="form-control"
                                                                value={this.state.test.show_description}
                                                                onChange={(e) => {
                                                                    let {test} = this.state;
                                                                    test.show_description = e.target.value;
                                                                    this.setState({test})
                                                                }}
                                                        >
                                                            <option value="yes">Yes</option>
                                                            <option value="no">No</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label>Answer Choices</label>
                                                        <select className="form-control"
                                                                value={this.state.test.answer_choices}
                                                                onChange={(e) => {
                                                                    let {test} = this.state;
                                                                    test.answer_choices = e.target.value;
                                                                    this.setState({test})
                                                                }}
                                                        >
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className={"col-md-12"}>
                                                    <label>Target Time</label>
                                                    <input className="form-control"
                                                           value={this.state.test.finish}
                                                           onChange={(e) => {
                                                            let {test} = this.state;
                                                            test.finish = e.target.value;
                                                            this.setState({test});
                                                           }}
                                                           />
                                                </div>

                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Instructions</label>
                                                        <textarea className="form-control" rows="3"
                                                                  value={this.state.test.instructions}
                                                                  onChange={(e) => {
                                                                      let {test} = this.state;
                                                                      test.instructions = e.target.value;
                                                                      this.setState({test})
                                                                  }}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="nav-tabs-custom no-bg row">
                                                <ul className="questionstable nav nav-tabs">
                                                    {this.state.test.sections.map((section, index) => {
                                                        return (
                                                            <li className={this.state.activeSection == index ? "active" : ""}><a onClick={(e) => {
                                                                e.preventDefault();
                                                                this.setState({activeSection: index});
                                                            }}>Section {index}</a></li>
                                                        )
                                                    })}

                                                    <li><a onClick={(e) => {
                                                        e.preventDefault();
                                                        let {test} = this.state;
                                                        test.sections.push({name: '', questions: [], subjectId: ''});
                                                        this.setState({test});
                                                    }}><i className={"zmdi zmdi-plus"}></i></a></li>

                                                </ul>
                                            </div>
                                            <br />
                                            {this.state.test.sections[this.state.activeSection] &&

                                            <div>

                                                {this.state.activeCourse.CourseSubject &&
                                                <select className="form-control"
                                                        onChange={(e) => {
                                                            let {test} = this.state;
                                                            test.sections[this.state.activeSection].subjectId = e.target.value;
                                                            this.setState({test});
                                                        }}
                                                        value={this.state.test.sections[this.state.activeSection].subjectId || ''}
                                                >

                                                    <option value={""}>Subject</option>
                                                    {this.state.activeCourse.CourseSubject.map(sub => {
                                                        return <option value={sub.id}>{sub.name}</option>
                                                    })}
                                                </select>
                                                }
                                            </div>


                                            }
                                            <br /><br />

                                            <div className="AddNewTestQuestiosModalWrapper">
                                                <div className="duplicateablequestion">
                                                    {
                                                        this.state.test.sections &&
                                                        this.renderQuestions(this.state.test.sections)}
                                                </div>
                                            </div>
                                            <br /><br />
                                            <a
                                                href="#"
                                                className="btn btn-info"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    let {test} = this.state;
                                                    test.sections[this.state.activeSection].questions.push(JSON.parse(JSON.stringify(questionTemplate)));
                                                    this.setState({test});
                                                }}
                                                // onclick="AddMoreQuestionToTheTest(this)"
                                            >
                                                <i className="zmdi zmdi-plus-circle"/>
                                                {this.state.test.sections[this.state.activeSection].questions.length > 0 ?
                                                    "Add Another Question"
                                                    : "Add a question"}

                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default EditChapterTest;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/EditChapterTest.js